import * as tslib_1 from "tslib";
import { map } from 'rxjs/operators';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidationTranslation, VALIDATORS } from '../validators';
import { hasProps } from '../helpers/object';
var ɵ0 = function (result, current) {
    var _a;
    return (tslib_1.__assign({}, result, (_a = {}, _a[current] = 'validation.' + current.toLowerCase(), _a)));
};
var validatorTranslations = VALIDATORS.reduce(ɵ0, {});
var TranslatedFormGroup = /** @class */ (function (_super) {
    tslib_1.__extends(TranslatedFormGroup, _super);
    function TranslatedFormGroup(fieldMap$, controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, controls, validatorOrOpts, asyncValidator) || this;
        fieldMap$.subscribe(function (map) { return _this.fieldMap = map; });
        return _this;
    }
    /**
     * Runs validation on the form group and returns all errors.
     */
    TranslatedFormGroup.prototype.validate = function () {
        var errors = ValidationTranslation.humanizeErrors(this, validatorTranslations, this.fieldMap);
        return {
            hasErrors: hasProps(errors), errors: errors
        };
    };
    return TranslatedFormGroup;
}(FormGroup));
export { TranslatedFormGroup };
var FormsService = /** @class */ (function () {
    function FormsService(translations) {
        this.translations = translations;
    }
    /**
     * Creates a translated form group
     * @param controlConfig The formgroup configuration object.
     */
    FormsService.prototype.group = function (config) {
        return new TranslatedFormGroup(this.translateFieldMap(config), this.createControls(config));
    };
    FormsService.prototype.createControls = function (controls) {
        var _this = this;
        return Object.keys(controls).reduce(function (controlDict, current) {
            var _a;
            return (tslib_1.__assign({}, controlDict, (_a = {}, _a[current] = _this.createSingle(controls[current]), _a)));
        }, {});
    };
    FormsService.prototype.createSingle = function (config) {
        if (this.isControlInstance(config)) {
            return config;
        }
        else if (Array.isArray(config)) {
            var value = config[0];
            var validators = config.length > 1
                ? config[1] : null;
            return new FormControl(value, validators);
        }
        else {
            return new FormControl(config);
        }
    };
    FormsService.prototype.isControlInstance = function (config) {
        return config instanceof FormControl
            || config instanceof FormGroup
            || config instanceof FormArray;
    };
    FormsService.prototype.translateFieldMap = function (config) {
        var fields = Object.keys(config);
        var translationCodes = [];
        var reverseLookup = {};
        fields.forEach(function (key) {
            var current = config[key];
            if (Array.isArray(current) && current.length > 2) {
                translationCodes.push(current[2]);
                reverseLookup[current[2]] = key;
            }
        });
        return this.translations
            .stream(translationCodes).pipe(map(function (translations) { return Object.keys(translations).reduce(function (result, key, i) {
            var _a;
            return (tslib_1.__assign({}, result, (_a = {}, _a[reverseLookup[key]] = translations[key], _a)));
        }, {}); }));
    };
    return FormsService;
}());
export { FormsService };
export { ɵ0 };
